frontApp.tooltip = {
  tippyOptions: {
    content(reference) {
      return reference.getAttribute('data-tooltip');
    },
    popperOptions: {
      modifiers: [
        {
          name: 'flip',
          options: {
            flipVariations: false,
          },
        },
      ],
    },
    zIndex: 1000,
    theme: 'light',
  },
  init() {
    tippy('[data-tooltip]', this.tippyOptions);
  },
};
